import { z } from "zod";

export const getWikiSpacesParamsSchema = z.object({
	spaceId: z.string(),
});
